const tg = window.Telegram.WebApp;

export function useTelegram() {
    const onClose = () => {
        tg.close();
    };

    const onFullSize = () => {
        tg.requestFullscreen();
    };
    const openChat = (username) => {
        tg.openTelegramLink(`https://t.me/${username}`);
        tg.minimize();

    };

    const triggerHapticFeedback = (type, impactStyle = null, notificationType = null) => {
        if (tg.HapticFeedback) {
            // Impact feedback
            if (type === 'impact' && impactStyle) {
                tg.HapticFeedback.impactOccurred(impactStyle);
            }
            // Notification feedback
            else if (type === 'notification' && notificationType) {
                tg.HapticFeedback.notificationOccurred(notificationType);
            }
            // Selection feedback
            else if (type === 'selection') {
                tg.HapticFeedback.selectionChanged();
            }
        }
    };
    // Method to check if the app is added to the home screen
    const checkHomeScreenStatus = async () => {
        try {
            const status = await tg.checkHomeScreenStatus();
            return status.added; // Returns true if already added
        } catch (error) {
            console.error("Error checking home screen status:", error);
            return false;
        }
    };

    // Method to prompt the user to add the app to the home screen
    const addToHomeScreen = async () => {
        try {
            await tg.addToHomeScreen();
        } catch (error) {
            console.error("Error adding app to home screen:", error);
        }
    };

    return {
        onFullSize,
        openChat,
        onClose,
        checkHomeScreenStatus,
        addToHomeScreen,
        tg,
        user: tg.initDataUnsafe?.user,
        queryId: tg.initDataUnsafe?.query_id,
        triggerHapticFeedback
    };
}
